<template>

    <div>
        <div>
            <div>
                <div
                        style="display: inline-flex !important;">
                    <!--ContextButtonGroupPager 로 교체 바랍니다.-->

                    <input @change="onFilenameChanged"
                           id="reg_file_name"
                           multiple ref="file"
                           style="float:left; width:185px;"
                           tabindex="2"
                           type="file"/>
                </div>

                <table>
                    <colgroup>
                        <col/>
                        <col/>
                        <col/>
                    </colgroup>
                    <thead>
                    <tr >
                        <th>파일명</th>
                        <th>크기</th>
                        <th>날짜</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in context.pageData.files" :key="item.id">
                        <td>{{item.name}}</td>
                        <td>{{item.size}}</td>
                        <td></td>
                    </tr>
                    </tbody>
                </table>

                <table>
                    <colgroup>
                        <col/>
                        <col/>
                    </colgroup>
                    <tbody>
                    <tr>
                        <td style="width: 20%;">
                            배포 버전
                        </td>
                        <td>
                            <input
                                    :placeholder='배포버전'
                                    data-vv-name="pageData.version"
                                    type="text"
                                    v-model="context.pageData.version"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                           Agent Type
                        </td>
                        <td>
                            <select
                                    v-model="context.pageData.type">
                                <option value="DV">DV</option>
                                <option value="PC">PC</option>
                            </select>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "MonitoringAgentFileUploadStep1",
        props: {
            value: {type: Object, default: undefined},
        },
        data: function () {
            return {
                context: this.value,

            };
        },
        watch: {
            context: {
                deep: true,
                handler: function(newValue, oldValue){
                    this.$emit('input', this.context);
                }
            },
        },
        methods: {
            onFileSelectionClicked() {
                this.toast('파일 선택!');
            },
            notifyDataToParent: function () {
                //this.$emit('onPage1DataChanged', this.pageData);
            },
            onFilenameChanged() {
                var self = this;

                if (this.$refs.file.files.length == 0)
                    return;

                this.context.pageData.files = [];

                this.$refs.file.files.forEach(function (item) {
                    self.context.pageData.files.push({name: item.name, size: item.size, file: item});
                    console.log(item.name);
                });
            }
        },
    }
</script>

<style scoped>

</style>